import { render } from "./LogoAndName.vue?vue&type=template&id=5534218e&scoped=true&ts=true"
import script from "./LogoAndName.vue?vue&type=script&lang=ts"
export * from "./LogoAndName.vue?vue&type=script&lang=ts"

import "./LogoAndName.vue?vue&type=style&index=0&id=5534218e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5534218e"]])

export default __exports__